export const DEV = import.meta.env.VITE_APP_DEV === "true";
export const STEAM = import.meta.env.VITE_APP_STEAM === "true";
export const MAC = window.navigator.platform === "MacIntel";